// src/utils/profileAssistantState.js

// Keys used in localStorage
const STEP_KEY = 'profileAssistantStep';
const FIRST_NAME_KEY = 'profileAssistant_firstName';
const LAST_NAME_KEY = 'profileAssistant_lastName';
const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Get current step
export function getSavedStep() {
  return localStorage.getItem(STEP_KEY);
}

// Save step
export function saveStep(step) {
  localStorage.setItem(STEP_KEY, step);
}

// Get first/last name
export function getSavedName() {
  return {
    firstName: localStorage.getItem(FIRST_NAME_KEY) || '',
    lastName: localStorage.getItem(LAST_NAME_KEY) || ''
  };
}

// Save first/last name
export function saveFirstName(name) {
  localStorage.setItem(FIRST_NAME_KEY, name);
}

export function saveLastName(name) {
  localStorage.setItem(LAST_NAME_KEY, name);
}

// Clear all state after onboarding complete
export function clearProfileAssistantState() {
  localStorage.removeItem(STEP_KEY);
  localStorage.removeItem(FIRST_NAME_KEY);
  localStorage.removeItem(LAST_NAME_KEY);
}
export const setStepAndStore = (stepSetter, nextStep) => {
  stepSetter(nextStep);
  saveStep(nextStep);
};
export async function persistStepToDatabase(step) {
  try {
    await fetch(`${BACKEND_URL}/api/users/update-onboarding-stage`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ u_onboarding_stage: step }),
    });
  } catch (err) {
    console.error('❌ Failed to update onboarding stage in DB:', err);
  }
}
